import boxVegetables from "@/assets/newcaja_verdura.png";
import boxLarge from "@/assets/photos/50/big.webp";
import boxFruits from "@/assets/photos/50/fruits.webp";
import boxMedium from "@/assets/photos/50/medium.webp";
import boxSmall from "@/assets/photos/50/small.webp";
import type { SubscriptionData } from "@/services/types";

const subscriptionImages: { [key: string]: string } = {
    "1": boxMedium,
    "2": boxLarge,
    "3": boxSmall,
    "4": boxFruits,
    "5": boxVegetables,
    BIG: boxLarge,
    LARGE: boxLarge,
    GRANDE: boxLarge,
    CG001: boxLarge,
    MEDIUM: boxMedium,
    MEDIANA: boxMedium,
    CM001: boxMedium,
    SMALL: boxSmall,
    CHICA: boxSmall,
    CP001: boxSmall,
    CS001: boxSmall,
    FRUITS: boxFruits,
    FRUTAS: boxFruits,
    CF001: boxFruits,
    VEGETABLES: boxVegetables,
    VERDURAS: boxVegetables,
    CV001: boxVegetables,
};

export const getSmallSubscriptionImage = (
    subscriptionId?: string | number | null,
) => {
    if (subscriptionId === undefined || subscriptionId === null) return "";

    return subscriptionImages[String(subscriptionId).toUpperCase()] || "";
};

export const getSubscriptionImage = (
    subscription?: Partial<SubscriptionData> | null,
) => {
    if (!subscription) return "";

    const name = subscription.name?.toUpperCase() ?? "";
    const candidates = [
        subscription.code,
        subscription.box_size,
        subscription.id,
        name.includes("VERDURA") ? "VEGETABLES" : undefined,
        name.includes("FRUTA") ? "FRUITS" : undefined,
        name.includes("GRANDE") ? "BIG" : undefined,
        name.includes("MEDIANA") ? "MEDIUM" : undefined,
        name.includes("CHICA") || name.includes("PEQUE") ? "SMALL" : undefined,
    ];

    for (const candidate of candidates) {
        const image = getSmallSubscriptionImage(candidate);
        if (image) return image;
    }

    return "";
};
